import React, { useState, useRef } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui";
import { StudentPopoverCard } from "./StudentPopoverCard";
import { Student } from "@/types/Student";

interface StudentPopoverProps {
  student: Partial<Student>;
  children: React.ReactNode;
  profileSource?: string;
}

export const StudentPopover = ({
  student,
  children,
  profileSource,
}: StudentPopoverProps) => {
  const [open, setOpen] = useState(false);
  const openTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const closeTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleMouseEnter = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }

    if (openTimeoutRef.current) {
      clearTimeout(openTimeoutRef.current);
    }

    openTimeoutRef.current = setTimeout(() => {
      setOpen(true);
    }, 500);
  };

  const handleMouseLeave = () => {
    if (openTimeoutRef.current) {
      clearTimeout(openTimeoutRef.current);
      openTimeoutRef.current = null;
    }

    closeTimeoutRef.current = setTimeout(() => {
      setOpen(false);
    }, 100);
  };

  return (
    <Popover open={open} onOpenChange={setOpen} data-testid="popover">
      <PopoverTrigger
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        asChild
        data-testid="popover-trigger"
      >
        <div className="cursor-pointer">{children}</div>
      </PopoverTrigger>
      <PopoverContent
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="w-80 rounded-sm p-0"
        data-testid="popover-content"
        side="left"
        align="start"
        sideOffset={12}
        alignOffset={0}
        avoidCollisions={true}
        collisionBoundary={[document.documentElement]}
        collisionPadding={16}
        sticky="partial"
      >
        <StudentPopoverCard student={student} profileSource={profileSource} />
      </PopoverContent>
    </Popover>
  );
};
